export enum IMChatType{
    CHAT_TEXT = 'CHAT_TEXT',
    CHAT_AUDIO = 'CHAT_AUDIO',
    CHAT_IMG = 'CHAT_IMG',
    BLOCK_USER = 'BLOCK_USER'  
}